<div class="mss-risk-assessment__card">
    <div class="mss-risk-assessment__card-content">
        <div class="mss-risk-assessment__card-title">
            Are you safe?
        </div>
        <div class="mss-risk-assessment__card-description">
            If your circumstances have changed, retake our risk assessment, so we can understand if you need
            support in a different way
        </div>
        <ion-button
            class="button-gray"
            [routerLink]="'/risk-assesment/' + tag">
            Take assessment
        </ion-button>
    </div>
    <ion-button
        expand="full"
        class="button-red mr-0 mb-0 ml-0">
        If you are in immediate danger, always call 999
    </ion-button>
</div>
